import API from '@/network/API'
import { CustomSuccessData } from 'axios'

const _baseUrl = '/restaurantPay/v1.0/public'

/**
 * 检查当天是否已经使用过会员菜品
 * @returns Promise<CustomSuccessData<boolean>> - true表示已使用过，false表示未使用过
 */
export async function checkMemberFreeItemsUsed(): Promise<CustomSuccessData<boolean>> {
  return API.instance().get<boolean>(`${_baseUrl}/memberFreeItemsUsed`)
}
